import { render, staticRenderFns } from "./AssignMenu.vue?vue&type=template&id=2a0b3951&scoped=true&"
import script from "./AssignMenu.vue?vue&type=script&lang=js&"
export * from "./AssignMenu.vue?vue&type=script&lang=js&"
import style0 from "./AssignMenu.vue?vue&type=style&index=0&id=2a0b3951&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0b3951",
  null
  
)

export default component.exports